import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Hero } from '@/components/sections/Hero'
import { Features } from '@/components/sections/Features'
import { FAQ } from '@/components/sections/FAQ'

gsap.registerPlugin(ScrollTrigger)

export function IndexPage() {
  const location = useLocation()

  // Handle hash navigation - refresh ScrollTrigger and scroll to section
  useEffect(() => {
    const hash = location.hash
    if (hash) {
      // Small delay to ensure DOM is ready and ScrollTrigger is initialized
      const timer = setTimeout(() => {
        ScrollTrigger.refresh()
        const element = document.querySelector(hash)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [location.hash])

  return (
    <>
      <Hero />
      <Features />
      <FAQ />
    </>
  )
}
